import { Fragment } from "react";

const staffedHoursRows = [
  { day: "Monday", time: "8am - 11am / 330pm - 630pm" },
  { day: "Tuesday, Wednesday & Thursday", time: "515am - 11am / 330pm - 630pm" },
  { day: "Friday", time: "6am - 12pm" },
  { day: "Saturday & Sunday", time: "AFTER HOURS ACCESS ONLY" },
];

const classTimetable = [
  { day: "Monday", sessions: [{ name: "Cardio", times: ["06:00", "09:30"] }] },
  { day: "Tuesday", sessions: [{ name: "Weights", times: ["06:00", "09:30"] }] },
  {
    day: "Wednesday",
    sessions: [
      { name: "Cardio", times: ["06:00"] },
      { name: "Weights", times: ["09:30"] },
    ],
  },
  { day: "Thursday", sessions: [{ name: "Weights", times: ["06:00"] }] },
];

export function StaffedHoursAndClasses() {
  return (
    <div className="section-shell">
      <div className="section-grid">
        <section className="section-column" id="hours" tabIndex={-1} aria-labelledby="hours-title">
          <span className="eyebrow">Your time. Your training.</span>
          <h2 className="section-title" id="hours-title">STAFFED HOURS</h2>
          <table className="hours-table" aria-label="Staffed hours">
            <tbody>
              {staffedHoursRows.map(({ day, time }) => (
                <tr key={day}>
                  <th scope="row">{day}</th>
                  <td>{time}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
        <section className="section-column classes-panel" id="classes" tabIndex={-1} aria-labelledby="classes-title">
          <span className="eyebrow">Included in your membership</span>
          <h2 className="section-title" id="classes-title">CLASSES</h2>
          <p className="body-copy">
            At Positive NRG all classes are included in your gym membership.
          </p>
          <h3 className="timetable-title" id="timetable-title">Weekly timetable</h3>
          <ul className="class-timetable" aria-labelledby="timetable-title">
            {classTimetable.map(({ day, sessions }) => (
              <li className="class-day" key={day}>
                <h4>{day}</h4>
                {sessions.map(({ name, times }) => (
                  <p className="class-session" key={name}>
                    <span>{name}</span>{" "}
                    <span className="class-times">
                      {times.map((time, index) => (
                        <Fragment key={time}>
                          {index > 0 && ", "}
                          <time dateTime={time}>{time.replace(/^0/, "")}am</time>
                        </Fragment>
                      ))}
                    </span>
                  </p>
                ))}
              </li>
            ))}
          </ul>
        </section>
      </div>
    </div>
  );
}
